import React, { useRef, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTextHeight, faImage } from "@fortawesome/free-solid-svg-icons";
import "./SidebarMenu.css";

const SidebarMenu = ({
  handleImageUpload,
  handleAddText,
  templates,
  activeTemplate,
  setActiveTemplate,
}) => {
  const fileInputRef = useRef(null);

  // Set selected template as active
  const handleSelectTemplate = (selectedTemplate) => {
    setActiveTemplate(selectedTemplate); // Mark as active
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="sidebar-menu">
      {/* Insert Section */}
      <h3 className="menu-title">Insert</h3>
      <div className="menu-grid">
        <div className="menu-item" onClick={handleAddText}>
          <FontAwesomeIcon icon={faTextHeight} className="icon text" />
          <p>Add Text</p>
        </div>

        <div className="menu-item" onClick={triggerFileInput}>
          <FontAwesomeIcon icon={faImage} className="icon image" />
          <p>Add Image</p>
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleImageUpload}
            ref={fileInputRef}
            style={{ display: "none" }}
          />
        </div>
      </div>

      {/* Templates Section - Sorted by Active Template */}
      <h3 className="menu-title">Templates</h3>
      <div className="content-blocks">
        {templates.length > 0 ? (
          templates.map((template, index) => (
            <div
              key={index}
              className="block-item"
              onClick={() => handleSelectTemplate(template)} // Set as active
              style={{
                cursor: "pointer",
                border:
                  activeTemplate === template
                    ? "3px solid #2185d0"
                    : "2px solid transparent", // Highlight active template
                borderRadius: "5px",
              }}
            >
              <div
                className="template-preview"
                style={{
                  backgroundColor: template.backgroundColor || "#ffffff",
                  backgroundImage: `url(${template.backgroundSmallImage})`,
                  backgroundSize: "cover",
                  width: "100%",
                  height: "100%",
                }}
              ></div>
            </div>
          ))
        ) : (
          <p>No templates available</p>
        )}
      </div>
    </div>
  );
};

export default SidebarMenu;
